import { ReactComponent as Healthcare } from "../../../../../../assets/images/icons/healthcare.svg";
import { ReactComponent as Banking } from "../../../../../../assets/images/icons/banking.svg";
import { ReactComponent as Advertising } from "../../../../../../assets/images/icons/advertising.svg";
import { ReactComponent as CommunicationServices } from "../../../../../../assets/images/icons/communicationservices.svg";
import { ReactComponent as LifeSciences } from "../../../../../../assets/images/icons/lifesciences.svg";
import { ReactComponent as Retail } from "../../../../../../assets/images/icons/retail.svg";
import { ReactComponent as Manufacturing } from "../../../../../../assets/images/icons/manufacturing.svg";
import { ReactComponent as Media } from "../../../../../../assets/images/icons/media.svg";
import { ReactComponent as Energy } from "../../../../../../assets/images/icons/energy.svg";
import { ReactComponent as Education } from "../../../../../../assets/images/icons/education.svg";
import { ReactComponent as Automotive } from "../../../../../../assets/images/icons/automotive.svg";
import { ReactComponent as Enterprise } from "../../../../../../assets/images/icons/enterprisetech.svg";
import { ReactComponent as Gaming } from "../../../../../../assets/images/icons/gaming.svg";
import { ReactComponent as Government } from "../../../../../../assets/images/icons/government.svg";
import { ReactComponent as Travel } from "../../../../../../assets/images/icons/travel.svg";
import { ReactComponent as RecommendationsEngine } from "../../../../../../assets/images/icons/recommendationengines.svg";
import { ReactComponent as CustomerSegmentation } from "../../../../../../assets/images/icons/customersegmentation.svg";
import { ReactComponent as AdEffectiveness } from "../../../../../../assets/images/icons/adeffectiveness.svg";
import { ReactComponent as PredictiveMaintenance } from "../../../../../../assets/images/icons/predictivemaintenance.svg";
import { ReactComponent as DataVisualization } from "../../../../../../assets/images/icons/datavisualization.svg";
import { ReactComponent as DiseasePrediction } from "../../../../../../assets/images/icons/diseaseprediction.svg";
import { ReactComponent as Tasks } from "../../../../../../assets/images/icons/tasks.svg";
import { ReactComponent as Anomaly } from "../../../../../../assets/images/icons/anomaly.svg";
import { ReactComponent as FileStoring } from "../../../../../../assets/images/icons/filestoring.svg";
import { ReactComponent as DeceptionSecurity } from "../../../../../../assets/images/icons/deception.svg";
import { ReactComponent as CustomerRetention } from "../../../../../../assets/images/icons/customerretention.svg";
import { ReactComponent as PerformanceManagement } from "../../../../../../assets/images/icons/performancemanagement.svg";
import { ReactComponent as CriminalDetection } from "../../../../../../assets/images/icons/criminaldetection.svg";
import { ReactComponent as PredictiveSales } from "../../../../../../assets/images/icons/predictivesales.svg";
import { ReactComponent as Developer } from "../../../../../../assets/images/icons/hostaidev.svg";
import { ReactComponent as Agriculture } from "../../../../../../assets/images/icons/agriculture.svg";
import { ReactComponent as Wildlife } from "../../../../../../assets/images/icons/wildlife.svg";
import { ReactComponent as Forest } from "../../../../../../assets/images/icons/forest.svg";
import { ReactComponent as Farming } from "../../../../../../assets/images/icons/farming.svg";
import { ReactComponent as Nature } from "../../../../../../assets/images/icons/nature.svg";
import { ReactComponent as AirQuality } from "../../../../../../assets/images/icons/airquality.svg";
import { ReactComponent as GeoAnalytics } from "../../../../../../assets/images/icons/geoanalytics.svg";
import { ReactComponent as Geographic } from "../../../../../../assets/images/icons/geographic.svg";
import { ReactComponent as Scientific } from "../../../../../../assets/images/icons/scientific.svg";
import { ReactComponent as Sanscript } from "../../../../../../assets/images/icons/sanscript.svg";
import { ReactComponent as Runes } from "../../../../../../assets/images/icons/runes.svg";
export const IndustrySolutions1 = [
  {
    icon: <Healthcare />,
    title: "Healthcare",
    desc: "Deliver patient-centric care with the power of data and AI",
    path: "/healthcare",
  },
  {
    icon: <Banking />,
    title: "Banking & Financial Services",
    desc: "Creating a more inclusive and safer financial services industry with HostAI",
    path: "/banking",
  },
  {
    icon: <Advertising />,
    title: "Advertising & Marketing",
    desc: "Big Data and AI to improve audience segmentation and targeting ",
    path: "/advertising",
  },
  {
    icon: <CommunicationServices />,
    title: "Communication Services ",
    desc: "HostAI helps media companies understand their audience and content better than ever ",
    path: "/webinars",
  },
  {
    icon: <LifeSciences />,
    title: "Life Sciences",
    desc: "Custom AI Services for scientists to build AI models for specific needs ",
    path: "/news",
  },
];
export const IndustrySolutions2 = [
  {
    icon: <Retail />,
    title: "Retail & Ecommerce",
    desc: "Deliver personalized and high quality brand experience with HostAI",
    path: "/trustcenter",
  },
  {
    icon: <Manufacturing />,
    title: "Manufacturing",
    desc: "Intelligent manufacturing and data analytics to maximize supply chain efficiencies",
    path: "/webinars",
  },
  {
    icon: <Media />,
    title: "Media & Entertainment",
    desc: "Explore the variety of solutions HostAI provides for media",
    path: "/news",
  },
  {
    icon: <Energy />,
    title: "Energy & Utilities",
    desc: "Improving Operational Efficiency with AI",
    path: "/webinars",
  },
  {
    icon: <Education />,
    title: "Education",
    desc: "Making educational institutions more effective with the power of data ",
    path: "/news",
  },
];
export const IndustrySolutions3 = [
  {
    icon: <Automotive />,
    title: "Automotive",
    desc: "Giving companies access to digital solutions that complement physical products ",
    path: "/trustcenter",
  },
  {
    icon: <Enterprise />,
    title: "Enterprise Technology",
    desc: "Creating next generation technologies through data analytics and ML",
    path: "/webinars",
  },
  {
    icon: <Gaming />,
    title: "Gaming",
    desc: "Deliver a tailored gaming experience using big data and AI ",
    path: "/news",
  },
  {
    icon: <Government />,
    title: "Government",
    desc: "Data analytics capabilities to better serve and protect communities",
    path: "/webinars",
  },
  {
    icon: <Travel />,
    title: "News",
    desc: "Advanced AI algorithms to power chatbots with increased efficiencies ",
    path: "/news",
  },
];
export const UseCaseSolutions1 = [
  {
    icon: <RecommendationsEngine />,
    title: "Recommendation Engines",
    desc: "Make recommendations that grow revenue by enhancing the customer experience",
    path: "/trustcenter",
  },
  {
    icon: <CustomerSegmentation />,
    title: "Customer Segmentation",
    desc: "Make your marketing more targeted by segmenting customers with AI",
    path: "/webinars",
  },
  {
    icon: <AdEffectiveness />,
    title: "Ad Effectiveness",
    desc: "AI systems to learn from, analyze, and measure marketing efforts ",
    path: "/news",
  },
  {
    icon: <PredictiveMaintenance />,
    title: "Predictive Maintenance",
    desc: "Implementing predictive maintenance can help oil and gas assets operate more efficiently",
    path: "/webinars",
  },
  {
    icon: <DataVisualization />,
    title: "Data Visualization",
    desc: "Visualize your data for better analytics and decision making. Let the data speak!",
    path: "/news",
  },
];
export const UseCaseSolutions2 = [
  {
    icon: <DiseasePrediction />,
    title: "Disease Prediction",
    desc: "Analyze chronic conditions with medical data lab data to enable early diagnosis",
    path: "/trustcenter",
  },
  {
    icon: <Tasks />,
    title: "In-Office Tasks",
    desc: "Virtual assistants that can handle in-office tasks for you",
    path: "/webinars",
  },
  {
    icon: <Anomaly />,
    title: "Anomaly Detection",
    desc: "Use anomaly detection and other approaches to identify fraud, non-compliant spending ",
    path: "/news",
  },
  {
    icon: <FileStoring />,
    title: "File Storing",
    desc: "Files are stored in secure cloud storage and easy to find and manage",
    path: "/webinars",
  },
  {
    icon: <DeceptionSecurity />,
    title: "Deception Security",
    desc: "Deploy decoy-assets in a network as bait for attackers to identify, track, and disrupt security threats ",
    path: "/news",
  },
];
export const UseCaseSolutions3 = [
  {
    icon: <CustomerRetention />,
    title: "Customer Retention",
    desc: "Use HostSales - our AI powered CRM System and never miss any lead",
    path: "/trustcenter",
  },
  {
    icon: <PerformanceManagement />,
    title: "Performance Management",
    desc: "Actualize your employee’s maximum professional potential with the right tools",
    path: "/webinars",
  },
  {
    icon: <CriminalDetection />,
    title: "Criminal Detection",
    desc: "By using HostAI, companies can identify areas of potential crimes ",
    path: "/news",
  },
  {
    icon: <PredictiveSales />,
    title: "Predictive Sales",
    desc: "Sales forecasting is automated with increased accuracy thanks to HostAI",
    path: "/webinars",
  },
  {
    icon: <Developer />,
    title: "HostAI Developer",
    desc: "Develop your custom AI solutions with companies experienced in AI development",
    path: "/news",
  },
];
export const HostAiEarth1 = [
  {
    icon: <Agriculture />,
    title: "Agricultural Metrics",
    desc: "Find, manage, and monetize food, farming, and environmental data",
    path: "/trustcenter",
  },
  {
    icon: <Wildlife />,
    title: "HostAI Wildlife",
    desc: "Automatically identify animals in videos or images and make it easier for researchers  ",
    path: "/webinars",
  },
  {
    icon: <Forest />,
    title: "HostAI Forest",
    desc: "Using aerial imagery and AI to survey forests for landowners to ease measuring and monitoring",
    path: "/news",
  },
];
export const HostAiEarth2 = [
  {
    icon: <Farming />,
    title: "Farming Analytics",
    desc: "HostAI uses sensors to collect data for specific plots of farmland",
    path: "/trustcenter",
  },
  {
    icon: <Nature />,
    title: "HostAI Nature",
    desc: "Receive smart conservation action for imperiled species and their habitat maps",
    path: "/webinars",
  },
];
export const HostAiEarth3 = [
  {
    icon: <AirQuality />,
    title: "Air Quality Control",
    desc: "Use AI and data to manage and improve air quality",
    path: "/trustcenter",
  },
  {
    icon: <GeoAnalytics />,
    title: "Geo Analytics",
    desc: "Enabling analysis of granular satellite imagery for predictions",
    path: "/webinars",
  },
];
export const Research1 = [
  {
    icon: <Geographic />,
    title: "HostAI Geographic",
    desc: "Tailored geographic tools for education purposes",
    path: "/trustcenter",
  },
  {
    icon: <Scientific />,
    title: "HostAI Scientific",
    desc: "AI engine for scientific text understanding, literature review and data extraction",
    path: "/webinars",
  },
];
export const Research2 = [
  {
    icon: <Sanscript />,
    title: "HostAI Sanscript",
    desc: "Sanskrit writing and reading engine for ancient texts ",
    path: "/trustcenter",
  },
];
export const Research3 = [
  {
    icon: <Runes />,
    title: "HostAI Runes",
    desc: "Runes writing and reading engine for ancient texts",
    path: "/trustcenter",
  },
];
